import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { StoreService } from './services/store.service';
import { combineLatest, of, Subscription, switchMap, tap } from 'rxjs';
import { OfflineService } from './services/offline.service';
import { ConnectionStatusService } from './services/connection-status.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  isLoggedIn = false;
  projectSelectionVisible$ = this.store.projectSelectVisible$;
  hasOffline$ = combineLatest([
    this.store.projectChanged$,
    this.connectionStatusService.networkStatus$,
    this.offlineService.offlineDataChanged$
  ]).pipe(
    switchMap(([project, isOnline]) => {
      if(!project || !isOnline) {
        return of(false);
      }
      return this.offlineService.hasProjectOfflineData(project.id)
    })
  );
  sub = new Subscription();

  // @HostListener('window:storage', ['$event'])
  // checkLoggedIn(event: any) {
  //   if (event.storageArea == localStorage) {
  //     const isLoggedIn = localStorage.getItem(LOCAL_STORAGE_KEYS.loggedIn);
  //
  //     if (!isLoggedIn) {
  //       this.store.logout();
  //     }
  //   }
  // }

  constructor(
    public store: StoreService,
    private renderer: Renderer2,
    private connectionStatusService: ConnectionStatusService,
    private offlineService: OfflineService,
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) {
  }

  public ngOnInit() {
    console.log('sprawdzam reload nowej wersji')
    this.sub.add(
      this.store.appReadyChanged$.subscribe(() => this.handleAppReady())
    );
    if (this.swUpdate.isEnabled) {
      this.sub.add(
        this.swUpdate.versionUpdates.pipe(
          tap((e) => console.log(e)),
          filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY')
        ).subscribe(() => {
          const snack = this.snackBar.open(
            this.translate.instant('NEW_VERSION_AVAILABLE'),
            this.translate.instant('REFRESH'),
            {
              duration: 0,
              panelClass: ['network-snackbar']
            }
          );
          snack.onAction().subscribe(() => {
            this.swUpdate.activateUpdate().then(() => document.location.reload());
          });
        })
      );
    }
  }

  private handleAppReady(): void {
    this.renderer.addClass(document.body, 'loaded');
    setTimeout(() => this.renderer.addClass(document.body, 'hide-loader'), 500);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
